/* eslint-disable @next/next/no-img-element */
import React, { useCallback, useMemo } from "react";
import { useDropzone } from "react-dropzone";
import { BsFileImage } from "react-icons/bs";
import { infoToast } from "@/lib/toast";
import { uploadBanner, uploadLogo } from "@/services/account.service";
import { getMediaCdnUrl } from "@/lib/cdn";

type MediaType = "logo" | "banner";
const UploadMedia = ({
  accountId,
  mediaType,
  value,
  onUpload,
}: {
  accountId: string;
  mediaType: MediaType;
  value?: string;
  onUpload?: () => void;
}) => {
  const onDrop = useCallback(
    async (acceptedFiles: Array<File>) => {
      infoToast("Upload en cours...");
      for (let file of acceptedFiles) {
        // Create a FormData instance
        const formData = new FormData();
        formData.append("media", file);
        if (mediaType === "logo") {
          await uploadLogo(formData);
        } else if (mediaType === "banner") {
          await uploadBanner(formData);
        }
      }
      infoToast("Upload terminé!");

      onUpload?.();
    },
    [mediaType, onUpload]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "image/*": [".png", ".jpg", ".jpeg", ".gif", ".webp", ".avif"],
    },
  });

  const current = useMemo(
    () => getMediaCdnUrl(accountId, mediaType, value),
    [accountId, mediaType, value]
  );

  return (
    <div
      {...getRootProps()}
      style={{
        border: "2px dashed gray-twist",
        padding: "20px",
        textAlign: "center",
      }}
      className="flex aspect-video h-[144px] cursor-pointer flex-col items-center justify-center space-y-2 rounded-md border border-dashed border-primary bg-slate-100"
    >
      <input {...getInputProps()} />

      {current ? (
        <img src={current} alt="logo" className="w-full h-full" />
      ) : (
        <div>
          <div className="text-primary">
            <BsFileImage size={44} />
          </div>
          <div className="font-semibold">Add your logo</div>
        </div>
      )}
    </div>
  );
};

export default UploadMedia;
